import React from 'react';
import { Text } from '../../../1elements';
import Pin from '../../../1elements/Icons/js/Pin';
import { englishTexts as words } from '../../../../consts/Texts';
import useTabHeader from './useTabHeader';

import CopyToClipboard from '../../../../v2/components/CopyToClipboard';
import PhoneNumber from '../../../../v2/components/PhoneNumber';

import './styles.scss';

// TODO: in further better to check this file and move to v2 folder
export default function TabHeader() {
  const { showMap, headerData } = useTabHeader();
  const {
    location_phone_number,
    loc_name,
    transit_id,
    location_job_id,
    address,
    address_coordinates
  } = headerData;

  return (
    <div className="wrapper">
      <div className="pipe thick section">
        <Text type="locationHeaderName" className="section-text">
          {loc_name}
        </Text>
      </div>

      <div
        onClick={() => showMap(address_coordinates)}
        className="pipe thick section last-section pin-wrapper"
      >
        <Pin width={13} height={15} fill="#393939" className="pin-class" />
        <Text
          type="locationHeader"
          className="section-text-secondary"
          title={address}
        >
          {address}
        </Text>
      </div>

      <div className="pipe thick section">
        <PhoneNumber phone={location_phone_number} />
      </div>

      <div className="pipe thick section">
        <Text type="locationHeaderLabel" className="section-text">
          {words.transitId}:{' '}
        </Text>
        <CopyToClipboard value={transit_id} />
      </div>
      <div className="pipe thick section">
        <Text type="locationHeaderLabel" className="section-text">
          Job ID:{' '}
        </Text>
        <CopyToClipboard value={location_job_id} />
      </div>
    </div>
  );
}
